module.exports = __webpack_public_path__ + "static/media/SP.387dd73b.png";